<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
  >
    <v-card height="100%">
      <v-card-title class="headline">
        Agregar Promo
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <!-- #### Name ############## -->
          <v-text-field
            v-model="itemData.name"
            outlined
            dense
            :rules="[validators.required]"
            :counter="100"
            label="Nombre"
            placeholder="Nombre"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### IsPercentage ############## -->
          <v-switch
            v-model="itemData.isPercentage"
            inset
            :label="`${itemData.isPercentage ? 'Es Porcentaje' : 'Es Monto'}`"
          ></v-switch>

          <!-- #### Value ############## -->
          <v-text-field
            v-model="itemData.value"
            outlined
            dense
            :rules="[validators.required]"
            label="Valor"
            placeholder="Valor"
            hide-details="auto"
            type="number"
            class="mb-6"
          ></v-text-field>

          <!-- #### Active ############## -->
          <v-switch
            v-model="itemData.active"
            inset
            :label="`${itemData.active ? 'Activo' : 'Inactivo'}`"
          ></v-switch>

          <v-btn
            :color="isEditMode ? 'info' : 'primary'"
            class="me-3"
            @click="OnSubmit()"
          >
            {{ isEditMode ? 'Actualizar' : 'Agregar' }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            @click="isDialogVisible = false"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import store from '@/store'

export default {

  setup(_, { emit }) {
    const isDialogVisible = ref(false)
    const isEditMode = ref(false)
    const valid = ref(true)

    const blankItemData = {
      name: null,
      isPercentage: false,
      value: 0,
      active: false,
    }

    const form = ref()

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const ClearForm = () => {
      if (form.value != null) {
        form.value.resetValidation()
      }
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
      isEditMode.value = false
    }

    const ShowDialog = item => {
      ClearForm()
      if (item) {
        itemData.value = item
        isEditMode.value = true
      }
      isDialogVisible.value = true
    }

    const OnSubmit = () => {
      if (form.value.validate()) {
        let mode = 'Insert'
        if (isEditMode.value === true) {
          mode = 'Update'
        }
        store.dispatch('promos/apiCall', { mode, request: itemData.value }).then(result => {
          if (result.success) {
            ClearForm()

            if (isEditMode.value === true) {
              emit('onUpdate')
            } else {
              emit('onInsert')
            }
            isDialogVisible.value = false
          }
        })
      }
    }

    return {
      isDialogVisible,
      valid,
      isEditMode,
      form,
      itemData,
      OnSubmit,
      ShowDialog,

      // validation
      validators: { required },
    }
  },
}
</script>
